import useBeforeUnloadConfirmation from '@gaia/utils/react/useBeforeUnloadConfirmation';
import {useCallback, useState} from 'react';

// we really don't care _what_ the promise does; we're just tracking when it settles
export type AddSavePromise = (promise: Promise<unknown>) => void;

/**
 * Keep track of promises that are currently saving. Returns a 2-tuple of the count of currently
 * pending promises, and a function to add a new promise to the list.
 */
export default function useIsSaved(): [number, AddSavePromise] {
    const [promises, setPromises] = useState<Promise<unknown>[]>([]);

    const addSavePromise: AddSavePromise = useCallback((promise: Promise<unknown>) => {
        setPromises((prev) => [...prev, promise]);
        // eslint-disable-next-line max-nested-callbacks
        promise.finally(() => setPromises((prev) => prev.filter((p) => p !== promise)));
    }, []);

    useBeforeUnloadConfirmation(promises.length > 0);

    return [promises.length, addSavePromise];
}
